// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f2UL","badges":"styles_badges__3uVY6"};